import to from "@/lib/to";

export async function setVolume(volume, http, videoDeviceId) {
  console.debug(`setting volume to ${volume} for video device ${videoDeviceId}`);
  if (volume >= 60 && volume <= 100) {
    if (videoDeviceId) {
      await to(http.post(`/video_devices/${videoDeviceId}/volume`, { volume }, {
        skipLoading: true,
        skipDivisions: true
      }));
    }
    return volume
  }
  return null
}